import { InputMode } from './input-mode';

export interface InputModeOption {
    name: string;
    mode: InputMode;
}

export const manualInputOption: InputModeOption = { name: 'GENERAL.TITLE.MANUAL_INPUT', mode: 'manual' };

export const barcodeInputOption: InputModeOption = {
    name: 'GENERAL.TITLE.QR_CODE_CAMERA_SCAN',
    mode: 'barcode',
};

export const nfcInputOption: InputModeOption = {
    name: 'GENERAL.TITLE.NFC_TAGS',
    mode: 'nfc',
};

export function getInputModeName(mode: InputMode) {
    switch (mode) {
        case 'barcode':
            return barcodeInputOption.name;
        case 'manual':
            return manualInputOption.name;
        case 'nfc':
            return nfcInputOption.name;
    }
}
